const updateWrap = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {

    }

    return state;
};

export default updateWrap;
